import moment, { Moment } from 'moment';

export function toLocalDateString(value: string | null | undefined): string | null {
  if (!value) return null;
  const momentValue = moment(value);
  if (!momentValue.isValid()) {
    console.warn(`Invalid date string: ${value}`);
    return null;
  }
  return momentValue.format('YYYY-MM-DD');
}

export function fromLocalDateString(s: string | null | undefined): Moment | null {
  if (!s) return null;
  return moment(s, 'YYYY-MM-DD');
}
